import React from 'react';
import { MapContainer, TileLayer, useMap, Marker, Popup, ZoomControl } from 'react-leaflet'
import "./OrderPage.css";
import Colors from '../Colors';
import Logo from '../logowhite.svg';
import API from '../API';
import L from "leaflet";

const pricings =[
  {
      name: "Motorsiklet",
      image: require("../assets/vehicles/araclar-13.svg").default,
  },{
      name: "Doblo",
      image: require("../assets/vehicles/araclar-10.svg").default,
  },{
      name: "Doblo",
      image: require("../assets/vehicles/araclar-10.svg").default,
  },{
      name: "Minivan",
      image: require("../assets/vehicles/araclar-14.svg").default,
  },{
      name: "Panelvan",
      image: require("../assets/vehicles/araclar-09.svg").default,
  },{
      name: "Kamyonet",
      image: require("../assets/vehicles/araclar-15.svg").default,
  }
]


export default class OrderPage extends React.Component {

    constructor(props) {
        super(props);

        var v = window.location.pathname.split("/");
        

        this.state = {loaded: false,error: undefined}

        
        API.fetch("getorder", {_id: v[2]}).then((order) => {
            
            if(order.error) {
                return this.setState({loaded: true, error: "Bu linkte bir sipariş bulunamadı"});
            }
            
            

            this.clockInterval = setInterval(() => {
              
              API.fetch("getorder", {_id: v[2]}).then((order) => {
                if(order.error) {
                  this.state.order.status = 10;
                  clearInterval(this.clockInterval);
                  
                } else {
                  if(!this.state.order.location && order.location) this.map.setView([order.location.l[1],order.location.l[0]]);
                  this.state.order = order;
                  this.forceUpdate();
                  
                }
              })
            }, 10000);

            this.setState({loaded: true,order});
        }).catch((e) => console.log(e));
    }


    render() {
      // if(!this.icon) this.icon = L.Icon({
      //   iconUrl: pricings[0].image,
      //   iconRetinaUrl: pricings[0].image,
      //   popupAnchor:  [-0, -0],
      //   iconSize: [32,45],    
      // })

      var plate = (this.state.order && this.state.order.assignedVehicle)?((this.state.order.assignedVehicle.plate.split("·").length > 1? this.state.order.assignedVehicle.plate:(pricings[this.state.order.vehicle].name + " · " +this.state.order.assignedVehicle.plate))):"";
        
        
        return <div style={{display:"flex",flex:1}}>
{this.state.loaded && this.state.error == undefined && <MapContainer ref={a => this.map = a} zoomControl={false} center={(this.state.order.location)?[this.state.order.location.l[1],this.state.order.location.l[0]]:[41.015137, 28.979530]} zoom={this.state.order.location?30:11} scrollWheelZoom={true}>
<TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    
      {window.innerWidth > 768 && <ZoomControl position='bottomright' />}
  {/* {this.state.order.location && this.state.order.status != 10 && <Marker position={[this.state.order.location.l[1],this.state.order.location.l[0]]}>

  </Marker>} */}


{this.state.order.location && this.state.order.status != 10 && <Marker icon={new L.icon({iconUrl: "https://tasimacim-driver-pictures.s3.eu-central-1.amazonaws.com/"+this.state.order.driverDetails._id+".jpeg", className:"markerIcon", iconSize: [40,40], popupAnchor:[0,-30]})} position={[this.state.order.location.l[1],this.state.order.location.l[0]]}>
    {/* <img src={pricings[this.state.order.vehicle].image} /> */}

    <Popup>
    Son lokasyon güncellenme zamanı {digit(new Date(this.state.order.location.time).getHours()) + ":" + digit(new Date(this.state.order.location.time).getMinutes())}
    </Popup>
</Marker>}
</MapContainer>}

{this.state.loaded && <div className='panelParent' style={{position:"absolute", zIndex:10000,display:"flex",flexDirection:"column", pointerEvents:"none", left:0, right:0, top:0, bottom:0,padding:10}}>
  
  
  <div style={{backgroundColor:"white", boxShadow:"0px 0px 5px -2px #000000", padding:10,borderRadius:3, display:"flex",width:"26%",paddingTop:13, paddingBottom:13}}>
    
    <img style={{width:60}} src={pricings[this.state.order.vehicle].image} />  

    <div style={{marginLeft:5, display:"flex", flex:1, flexDirection:"column"}}>

      <p style={{fontWeight:"600"}}>{this.state.order.status == 0?"Sürücü aranıyor":this.state.order.status==1?"Sürücü bulundu":this.state.order.status==10?"Teslim edildi":"Sürücü yolda"}</p>
      
      <p className={'overflow'+((this.state.order.status == 2)?" needed":" ")}>{this.state.order.status == 0?"Siparişiniz için en uygun sürücüyü bulmaya çalışıyoruz":this.state.order.status==1?"Sürücünüz yola çıkmak için hazır":getAddressLabel((this.state.order.currentWaypoint == 0)?this.state.order.from:(this.state.order.currentWaypoint == this.state.order.waypoints.length+1)?this.state.order.to:this.state.order.waypoints[this.state.order.currentWaypoint])}</p>
    </div>

    
  </div>  

  <div style={{backgroundColor:"white", boxShadow:"0px 0px 5px -2px #000000", padding:10,borderRadius:3, display:"flex",flexDirection:"column",width:"26%",paddingTop:13, paddingBottom:13,marginTop:10}}>
    {this.state.order.status > 0  && <><div style={{display:"flex", alignItems:"center"}}>
    <img style={{width:50, borderRadius:1000,marginLeft:5,marginRight:10}} src={"https://tasimacim-driver-pictures.s3.eu-central-1.amazonaws.com/"+this.state.order.driverDetails._id+".jpeg"} />  

    <div style={{marginLeft:5, display:"flex", flex:1, flexDirection:"column"}}>

      <p style={{fontWeight:"600"}}>{this.state.order.driverDetails.name}</p>
      <p className='overflow'>{plate}</p>
    </div>


    

    </div>

    <div style={{marginLeft:"1%", width:"98%", marginTop:15, marginBottom:0, height:2, backgroundColor:"#EFF0F1"}}></div></>}
    <Waypoint title={getAddressLabel(this.state.order.from)} />
    {this.state.order.waypoints.map((x, i) => <Waypoint key={i} title={getAddressLabel(x)} />)}
    <Waypoint title={getAddressLabel(this.state.order.to)} />
  </div>  
</div>}


            <div className='loadingPanel'  style={{display:"flex",pointerEvents:(this.state.loaded && this.state.error == undefined)?"none":"all",opacity: (this.state.loaded && this.state.error == undefined)?0:1,transition:"all 250ms",flexDirection:"column", left:0, right:0, top:0, bottom:0,justifyContent:"center", alignItems:"center", position:"absolute", backgroundColor:Colors.Blue}}>
                    <img src={Logo}  />
                    {!this.state.loaded && <div className="spinner-container loading">
      <div className="loading-spinner">
      </div>
    </div>}
                    {this.state.loaded && this.state.error != undefined && <p style={{textAlign:"center", color:"white"}}>{this.state.error}</p>}
            </div>
        </div>
    }
}




function getAddressLabel (address)  {
  var extras = "";
  if(address) {
    // if(address.extra.buildingNO) extras += address.extra.buildingNO + " ";
    // if(address.extra.floorNO) extras += address.extra.floorNO + " ";
    if(address.building) extras += global.getText("buildingShort")+": "+address.building + " ";
    if(address.floor) extras += global.getText("floorShort")+": "+address.floor + " ";
    if(address.door) extras += global.getText("noShort")+": "+address.door + " ";
    if(address.contactName) extras += (extras != ''?" · ":"")+address.contactName + " ";
    if(address.contactNO) extras += (extras != '' && !address.contactName?" · ":"")+address.contactNO;
    extras = extras.replace(/\s{2,}/g, ' ').trim();
  }

  return address.Label + ((extras.length > 0)?" · "+extras:"");
}

const Waypoint = (props) => {
    return <div style={{marginTop:15,display:"flex", position:"relative", paddingLeft:15, alignItems:"center"}} className='waypointInput'>
    <svg width="24" height="24" viewBox="0 0 24 24"><g fill="none"><path fill="#4B9D2A" d="M12.585 21.336l-.585.512-.585-.512C6.499 17.034 4 13.286 4 10a8 8 0 1 1 16 0c0 3.286-2.499 7.034-7.415 11.336z"></path><path fill="#FFF" d="M12 7.444c1.655 0 3 1.348 3 3.002a3.002 3.002 0 0 1-3 2.998c-1.655 0-3-1.347-3-3a3.002 3.002 0 0 1 3-3z"></path></g></svg>
    <div style={{width:"100%", marginLeft:15, alignItems:"center"}}>
    <p>{props.title}</p>
    
    

    </div>
    
</div>

}

function digit(num) {
  return `${num}`.padStart(2, '0');
}